// extracted by mini-css-extract-plugin
module.exports = {"body":"RequestsBlock_body__fAsYJ"};